export class FetchError extends Error {
  constructor(public readonly res: Response, message?: string) {
    super(message)
  }
}
